import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'mage-react-router';
import { kebabCase } from 'lodash';
import moment from 'moment';
import push from 'push.js';

import Dialog from '../Dialog';

import {
  ACCOUNT_TYPES,
  DATE_FORMAT,
  LS_HEADHUNTER_PASSWORD_UPDATE_NOTIFICATION,
  LS_PASSWORD_UPDATE_NOTIFICATION,
  PWD_LEVELS,
  ROLES,
} from '@/constants/common';
import { getLocalStorage, setLocalStorage } from '@/utils/common';
import { getI18n } from '@/utils/i18n';

const i18n = getI18n();

class Warning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSetupWelcome: true,
      showApplyModal: false,
      showExpired: true,
      showMailPasswordError: true,
      showNoMailError: true,
      showNoLagouAccountError: true,
      showBrowserNotificationError: true,
      showPwdUpdateNotification: true,
    };

    this.close = this.close.bind(this);
    this.checkStateAndLocalStorageToShow = this.checkStateAndLocalStorageToShow.bind(this);

    this.applyToBuy = this.applyToBuy.bind(this);
    this.applyToPwdUpdate = this.applyToPwdUpdate.bind(this);
    this.closeModal = this.closeModal.bind(this);

    const pwdUpdateWarn = {
      // 密码更换提醒。
      type: () => 'info',
      isShow: () => {
        if (!this.state.showPwdUpdateNotification) {
          return false;
        }
        const { accountType, currentUser } = this.props;
        if (currentUser.passwordLevel !== PWD_LEVELS.OLD) {
          // 只有密码规则之前的密码会被提醒更新。
          return false;
        }
        const userId = currentUser.id;
        // 如果noticeTime 。如果不存在，设置noticeTime为当前时间5天后，并提醒。如果存在，小于当前时间不提醒，大于当前时间，提醒更新密码并且设置为当前时间五天后
        const noticeTime = getLocalStorage(
          accountType === ACCOUNT_TYPES.USER
            ? LS_PASSWORD_UPDATE_NOTIFICATION
            : LS_HEADHUNTER_PASSWORD_UPDATE_NOTIFICATION,
          null,
          { userId }
        );
        if (noticeTime !== null && moment() < moment(noticeTime)) {
          return false;
        } else {
          return true;
        }
      },
      render: () => {
        return (
          <span className="warning__container__text">
            {i18n.t`Moka密码安全机制升级，为了您的账户安全，建议您`}
            <a className="warning__container__link" onClick={this.applyToPwdUpdate}>
              {i18n.t`更改密码`}
            </a>
          </span>
        );
      },
      onClose: () => {
        const { accountType, currentUser } = this.props;
        const userId = currentUser.id;
        setLocalStorage(
          accountType === ACCOUNT_TYPES.USER
            ? LS_PASSWORD_UPDATE_NOTIFICATION
            : LS_HEADHUNTER_PASSWORD_UPDATE_NOTIFICATION,
          moment().add(5, 'days').valueOf(),
          { userId }
        );
        this.setState({ showPwdUpdateNotification: false });
      },
    };
    /**
     * this.warnings包含所有提示内容及其显示机制,根据accountType区分不同的提示内容。猎头当前只有密码更新通知。
     *
     * 示例：添加一个新的提示
     * {
     *    type: () => 'warn', //提示的级别，现有info、warn和danger三种，对应三种背景颜色
     *    isShow: () => true, //显示条件, 函数返回真值则显示该提示
     *    render: () => (<span>我是一个提示</span>), //提示内容
     *    onClose: () => {}, //关闭提示后触发
     * }
     */
    this.warnings =
      props.accountType === ACCOUNT_TYPES.HEADHUNTER
        ? [pwdUpdateWarn]
        : [
            pwdUpdateWarn,
            {
              // 开通账号欢迎提示
              type: () => 'info',
              isShow: () =>
                this.props.info.createdAt &&
                moment(this.props.info.createdAt).diff(moment(), 'days') === 0 &&
                this.checkStateAndLocalStorageToShow('showSetupWelcome'),
              render: () => (
                <span className="warning__container__text">{i18n.t`帐号已开通，开始使用Moka吧！`}</span>
              ),
              onClose: this.close('showSetupWelcome'),
            },
            {
              // 临近过期提示
              type: () => {
                const expiredDiff = moment(this.props.info.expiredAt).diff(moment(), 'days');
                switch (expiredDiff) {
                  case 7:
                  case 5:
                    return 'warn';
                  case 3:
                  case 2:
                  case 1:
                  case 0:
                    return 'danger';
                }
              },
              isShow: () =>
                this.props.info.expiredAt &&
                [0, 1, 2, 3, 5, 7].includes(
                  moment(this.props.info.expiredAt).diff(moment(), 'days')
                ) &&
                this.props.info.pay === 0 &&
                this.checkStateAndLocalStorageToShow('showExpired'),
              render: () => {
                const expiredDiff = moment(this.props.info.expiredAt).diff(moment(), 'days');
                return (
                  <span className="warning__container__text">
                    {i18n.t`您的试用期将于${
                      expiredDiff ? expiredDiff : 1
                    }天后结束，届时所有功能将被冻结，购买后立即恢复，如需继续使用，点此`}
                    <a className="warning__container__link" onClick={this.applyToBuy}>
                      {i18n.t`申请购买`}
                    </a>
                  </span>
                );
              },
              onClose: this.close('showExpired'),
            },
            {
              // 简历邮箱密码变更提示
              type: () => 'danger',
              isShow: () =>
                !/^\/settings/.test(this.props.pathname) &&
                this.checkStateAndLocalStorageToShow('showMailPasswordError') &&
                (this.props.info.emails || []).some(
                  ({ tpEmail, showInvalid }) => tpEmail && showInvalid
                ),
              render: () => (
                <span className="warning__container__text">
                  {i18n.t`您好，系统检测到您绑定的接收简历邮箱`}{' '}
                  {this.props.info.emails
                    .filter(({ showInvalid }) => showInvalid)
                    .map(({ tpEmail }) => tpEmail)
                    .join(',')}{' '}
                  {i18n.t`密码变更，请`}
                  <Link className="warning__container__link" to="/settings/tp_email">
                    {i18n.t`重新设置`}
                  </Link>
                </span>
              ),
              onClose: this.close('showMailPasswordError'),
            },
            {
              // 拉勾密码错误提示
              type: () => 'danger',
              isShow: () =>
                !/^\/settings/.test(this.props.pathname) &&
                this.checkStateAndLocalStorageToShow('showNoLagouAccountError') &&
                this.props.lagouAccounts.length &&
                this.props.lagouAccounts.some(({ username, valid }) => username && !valid),
              render: () => (
                <span className="warning__container__text">
                  {i18n.t`您好，系统检测到您绑定的拉勾账号密码错误，请`}
                  <Link className="warning__container__link" to="/settings/sourceAccount">
                    {i18n.t`重新设置`}
                  </Link>
                </span>
              ),
              onClose: this.close('showNoLagouAccountError'),
            },
            {
              // 浏览器通知没有授权提示
              type: () => 'danger',
              isShow: () =>
                this.props.browserNotificationEnabled &&
                push.Permission.get() === push.Permission.DENIED &&
                this.checkStateAndLocalStorageToShow('showBrowserNotificationError'),
              render: () => (
                <span className="warning__container__text">
                  {i18n.t`您禁止了浏览器向您推送通知，您将不能及时收到重要的通知提醒。`}
                  <a
                    className="warning__container__link"
                    target="_blank"
                    href="https://mokahr.moyincloud.com/xtyy/jcsm/llqtzbjzrhkq.html?from=tip-浏览器通知被禁止如何开启"
                  >
                    {i18n.t`如何开启？`}
                  </a>
                </span>
              ),
              onClose: this.close('showBrowserNotificationError'),
            },
          ];
  }

  close(field) {
    return () => {
      setLocalStorage(`moka-${kebabCase(field)}-closed-time`, moment().format(DATE_FORMAT));
      this.setState({ [field]: false });
    };
  }

  checkStateAndLocalStorageToShow(field) {
    return (
      this.props.currentUser.role >= ROLES.HR &&
      this.state[field] &&
      getLocalStorage(`moka-${kebabCase(field)}-closed-time`) !== moment().format(DATE_FORMAT)
    );
  }

  applyToBuy() {
    this.setState({ showApplyModal: true });
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
        console.log('applied');
      }
    };
    xmlhttp.open('PUT', '/api/apply-to-buy', true);
    xmlhttp.send({});
  }

  applyToPwdUpdate() {
    const { accountType, currentUser, onShowPasswordDialog } = this.props;
    const userId = currentUser.id;
    setLocalStorage(
      accountType === ACCOUNT_TYPES.USER
        ? LS_PASSWORD_UPDATE_NOTIFICATION
        : LS_HEADHUNTER_PASSWORD_UPDATE_NOTIFICATION,
      moment().add(5, 'days').valueOf(),
      { userId }
    );
    this.setState({ showPwdUpdateNotification: false });
    if (accountType === ACCOUNT_TYPES.USER) {
      this.props.history.push({ pathname: '/settings/profile', query: { updatePassword: 1 } });
    } else if (accountType === ACCOUNT_TYPES.HEADHUNTER) {
      this.props.history.push({ pathname: '/headhunters' });
    }
    if (onShowPasswordDialog) {
      onShowPasswordDialog();
    }
  }

  closeModal() {
    this.setState({ showApplyModal: false });
  }

  render() {
    return (
      <div className="warning__container">
        {this.warnings.map((warning, idx) => {
          return warning.isShow() ? (
            <div className={`warning__container__item--${warning.type()}`} key={idx}>
              {warning.render()}
              <span className="warning__container__cancel icon-cross" onClick={warning.onClose} />
            </div>
          ) : null;
        })}
        <Dialog
          size="sm"
          isOpen={this.state.showApplyModal}
          className="expired-apply-modal"
          onCancel={this.closeModal}
          confirmClosing={false}
        >
          <div className="expired-apply-modal__title">
            <span className="icon-input-success" />
            {i18n.t`申请成功`}
          </div>

          <div className="expired-apply-modal__desc">
            {i18n.t`我们会尽快与您联系，您也可以咨询`}：010-57134227
            <br />（{i18n.t`工作时间：周一至周五`} 09:30-20:00）
          </div>
        </Dialog>
      </div>
    );
  }
}

Warning.propTypes = {
  info: PropTypes.object.isRequired,
  lagouAccounts: PropTypes.array.isRequired,
  pathname: PropTypes.string.isRequired,
  browserNotificationEnabled: PropTypes.bool.isRequired,
  currentUser: PropTypes.object.isRequired,
  accountType: PropTypes.string.isRequired,
  onShowPasswordDialog: PropTypes.func,
};

export default withRouter(Warning);
